<template>
  <div>
    <section>
      <v-parallax src="/images/price_top.jpeg" height="460">
        <v-row align-content="center" class="position-relative">
          <v-row class="text-center mt-15 mt-sm-10 mb-5 mb-sm-12 full-width">
            <v-col class="pa-1">
              <h1 class="text-xs-center pretopia-head-font pretopia-display-3 white--text text-shadow">
                30% på alla abonnemang!
              </h1>
              <h2 class="text-center py-3 white--text text-shadow">För dig som besökte oss på Formex</h2>
            </v-col>
          </v-row>
        </v-row>
      </v-parallax>
    </section>

    <v-container style="margin-top: -140px">
      <v-row class="mt-5">
        <v-col cols="12" sm="6" md="4" xl="" class="d-flex">
          <v-card class="d-flex flex-column">
            <v-card-title class="pt-6 justify-center">BASIC</v-card-title>
            <v-card-text class="text-body-1 font-italic pb-4"
              >Nå landets viktigaste redaktioner och frilansare.</v-card-text
            >
            <v-card-text>
              <ul class="text-body-1">
                <li class="pb-2">Medlem i bildbanken och därmed unik tillgång till landets stora magasin</li>
                <li class="pb-2">30st bilder i bildbanken.</li>
                <li class="pb-2">Kostnadsfri support</li>
                <li class="pb-2">Statistik över nedladdningar</li>
                <li class="pb-2">Månatliga ROI-rapporter</li>
              </ul>
            </v-card-text>
            <div class="flex-grow-1"></div>
            <v-card-actions class="justify-center">
              <v-btn color="primary" class="buy-button" @click="signupVendorFromFormex('basic')">KÖP</v-btn>
            </v-card-actions>
            <v-card-subtitle class="font-italic font-weight-bold red--text">
              Mässpris: 4 235 kr/år (1 815 kr/rabatt) *
            </v-card-subtitle>
            <v-card-subtitle class="font-italic pt-0"> Ordinarie pris: 6 050 kr/år. </v-card-subtitle>
          </v-card>
        </v-col>
        <v-col cols="12" sm="6" md="4" xl="" class="d-flex">
          <v-card class="d-flex flex-column">
            <div class="price-badge absolute px-10 py-1 rounded-pill text-body-2">POPULÄRAST</div>
            <v-card-title class="pt-6 justify-center">STANDARD</v-card-title>
            <v-card-text class="text-body-1 font-italic pb-4"
              >För dig som vill ha ut mer av ditt medlemsskap hos oss.</v-card-text
            >
            <v-card-text>
              <ul class="text-body-1">
                <li class="pb-2">Medlem i bildbanken och därmed unik tillgång till landets stora magasin</li>
                <li class="pb-2">Publicitet under nyhetssidan på Pretopias startsida av minst ett instagram inlägg.</li>
                <li class="pb-2">50st bilder i bildbanken</li>
                <li class="pb-2">5 exponeringar i sociala medier (i samråd med er)</li>
                <li class="pb-2">1 eget nyhetsbrev (i samråd med er)</li>
                <li class="pb-2">Kostnadsfri support</li>
                <li class="pb-2">Statistik över nedladdningar</li>
                <li class="pb-2">Månatliga ROI- rapporter</li>
                <li class="pb-2">Sporadisk medverkan i sociala medier kan förekomma.</li>
              </ul>
            </v-card-text>
            <div class="flex-grow-1"></div>
            <v-card-actions class="justify-center">
              <v-btn color="primary" class="buy-button" @click="signupVendorFromFormex('standard')">KÖP</v-btn>
            </v-card-actions>
            <v-card-subtitle class="font-italic font-weight-bold red--text">
              Mässpris: 8 239 kr/år (3 531 kr/rabatt) *
            </v-card-subtitle>
            <v-card-subtitle class="font-italic pt-0">
              Ordinarie pris: 11 770 kr/år.
            </v-card-subtitle>
          </v-card>
        </v-col>
        <v-col cols="12" sm="6" md="4" xl="" class="d-flex">
          <v-card class="d-flex flex-column">
            <v-card-title class="pt-6 justify-center">PREMIUM</v-card-title>
            <v-card-text class="text-body-1 font-italic pb-4">För dig som vill synas ännu mer.</v-card-text>
            <v-card-text>
              <ul class="text-body-1">
                <li class="pb-2">Medlem i bildbanken och därmed unik tillgång till landets stora magasin</li>
                <li class="pb-2">Publicitet under nyhetssidan på Pretopias startsida av minst ett instagram inlägg.</li>
                <li class="pb-2">Kostnadsfri rådgivning</li>
                <li class="pb-2">100st bilder i bildbanken</li>
                <li class="pb-2">10 exponeringar i sociala medier (i samråd med er)</li>
                <li class="pb-2">2 egna nyhetsbrev (i samråd med er)</li>
                <li class="pb-2">Kostnadsfri support</li>
                <li class="pb-2">Statistik över nedladdningar</li>
                <li class="pb-2">Månatliga ROI- rapporter</li>
                <li class="pb-2">Sporadisk medverkan i sociala medier kan förekomma</li>
              </ul>
            </v-card-text>
            <v-card-actions class="justify-center">
              <v-btn color="primary" class="buy-button" @click="signupVendorFromFormex('premium')">KÖP</v-btn>
            </v-card-actions>
            <v-card-subtitle class="font-italic font-weight-bold red--text">
              Mässpris: 13 090 kr/år (5 610 kr/rabatt) *
            </v-card-subtitle>
            <v-card-subtitle class="font-italic pt-0">
              Ordinarie pris: 18 700 kr/år.
            </v-card-subtitle>
          </v-card>
        </v-col>
        <v-col cols="12" sm="6" md="4" xl="" class="d-flex">
          <v-card class="d-flex flex-column">
            <v-card-title class="pt-6 justify-center">PREMIUM +</v-card-title>
            <v-card-text class="text-body-1 font-italic pb-4">För dig som vill ha lite mer av allt...</v-card-text>
            <v-card-text>
              <ul class="text-body-1">
                <li class="pb-2">Medlem i bildbanken och därmed unik tillgång till landets stora magasin</li>
                <li class="pb-2">Publicitet under nyhetssidan på Pretopias startsida av minst ett instagram inlägg</li>
                <li class="pb-2">Kostnadsfri rådgivning</li>
                <li class="pb-2">150st bilder i bildbanken</li>
                <li class="pb-2">12 exponeringar i sociala medier (i samråd med er)</li>
                <li class="pb-2">3 egna nyhetsbrev (i samråd med er)</li>
                <li class="pb-2">Kostnadsfri support</li>
                <li class="pb-2">Statistik över nedladdningar</li>
                <li class="pb-2">Månatliga ROI- rapporter</li>
                <li class="pb-2">Sporadisk medverkan i sociala medier kan förekomma</li>
              </ul>
            </v-card-text>
            <v-card-actions class="justify-center">
              <v-btn color="primary" class="buy-button" @click="signupVendorFromFormex('premium_plus')">KÖP</v-btn>
            </v-card-actions>
            <v-card-subtitle class="font-italic font-weight-bold red--text">
              Mässpris: 16 093 kr/år (6 897 kr/rabatt) *
            </v-card-subtitle>
            <v-card-subtitle class="font-italic pt-0">
              Ordinarie pris: 22 990 kr/år.
            </v-card-subtitle>
          </v-card>
        </v-col>
        <v-col cols="12" sm="6" md="4" xl="" class="d-flex">
          <v-card class="d-flex flex-column">
            <v-card-title class="pt-6 justify-center">GRANDE</v-card-title>
            <v-card-text class="text-body-1 font-italic pb-4">Maximera ditt genomslag i alla kanaler</v-card-text>
            <v-card-text>
              <ul class="text-body-1">
                <li class="pb-2">Medlem i bildbanken och därmed unik tillgång till landets stora magasin</li>
                <li class="pb-2">Publicitet under nyhetssidan på Pretopias startsida av minst ett instagram inlägg</li>
                <li class="pb-2">Kostnadsfri rådgivning</li>
                <li class="pb-2">200st bilder i bildbanken</li>
                <li class="pb-2">15 exponeringar i sociala medier (i samråd med er)</li>
                <li class="pb-2">4 egna nyhetsbrev (i samråd med er)</li>
                <li class="pb-2">Kostnadsfri support</li>
                <li class="pb-2">Statistik över nedladdningar</li>
                <li class="pb-2">Månatliga ROI- rapporter</li>
                <li class="pb-2">Sporadisk medverkan i sociala medier kan förekomma</li>
              </ul>
            </v-card-text>
            <v-card-actions class="justify-center">
              <v-btn color="primary" class="buy-button" @click="signupVendorFromFormex('grande')">KÖP</v-btn>
            </v-card-actions>
            <v-card-subtitle class="font-italic font-weight-bold red--text">
              Mässpris: 19 404 kr/år (8 316 kr/rabatt) *
            </v-card-subtitle>
            <v-card-subtitle class="font-italic pt-0">
              Ordinarie pris: 27 720 kr/år.
            </v-card-subtitle>
          </v-card>
        </v-col>
      </v-row>

      <v-row class="mt-9">
        <v-col class="mb-10">
          <span class="font-italic">* Gäller första året och endast på nya abonnemang som tecknas under mässan.</span>
          <br /><br />

          Paketen kan när som helst under året uppgraderas till ett större paket.<br />
          Det går även att köpa till utrymme för fler antal bilder eller nyhetsbrev, oavsett paket. Hör av er till oss
          hur många bilder ni vill att ert konto ska rymma eller hur många nyhetsbrev ni vill ha så återkommer vi med
          offert. <br />
          Vi erbjuder även total administration av kontot då vi byter ut, tar bort och lägger till bilder efter ert
          önskemål.<br />
          <span class="font-italic">Alla priser exkl moms.</span>

          <h3 class="mt-3 mb-4">Passar inte paketen dig? <br />Vi skräddarsyr ett paket efter dina önskemål!</h3>
          <p><router-link to="contactus">Kontakta oss så pratar vi igenom vad ni har för önskemål.</router-link></p>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  mounted() {
    if (window.scrollTo) {
      window.scrollTo(0, 0);
    }
  },

  methods: {
    signupVendorFromFormex(selectedPacket) {
      this.$router.push({ path: 'formexform', query: { subscription: selectedPacket } });
    },
  },
};
</script>

<style scoped>
.price-badge {
  position: absolute;
  top: -16px;
  transform: translateX(50%);
  right: 50%;
  border: 1px solid #d1bf89 !important;
  background-color: #efe2b9 !important;
}
.text-shadow {
  text-shadow: 2px 2px 6px black;
}

.buy-button {
  width: 100%;
  font-size: 1em;
  height: 41px;
}
</style>
